<template>
  <div>
    <div class="header">
      <site-topbar></site-topbar>
      <site-header></site-header>
      <site-category></site-category>
    </div>
    <home-hero></home-hero>
    <page-main></page-main>
    <site-footer></site-footer>
    <site-info></site-info>
    <home-tool-bar></home-tool-bar>
  </div>
</template>
<script>
import SiteTopbar from "../Layout/SiteTopbar.vue";
import SiteHeader from "../Layout/SiteHeader.vue";
import SiteFooter from "../Layout/SiteFooter.vue";
import HomeToolBar from "../Layout/HomeToolBar.vue";
import SiteInfo from "../Layout/SiteInfo.vue";
import SiteCategory from "./SiteCategory.vue";

import HomeHero from "./HomeHero.vue";
import PageMain from "./PageMain.vue";

export default {
  components: {
    "site-topbar": SiteTopbar,
    "site-header": SiteHeader,
    "home-hero": HomeHero,
    "page-main": PageMain,
    "site-footer": SiteFooter,
    "site-info": SiteInfo,
    "site-category": SiteCategory,
    "home-tool-bar": HomeToolBar,
  },
  name: "Home",
  props: {
    msg: String,
  },
};
</script>
<style>
@import "../../assets/css/home.css";

.site-header .nav-category .link-category.hidden {
  visibility: hidden;
}
</style>
